// extracted by mini-css-extract-plugin
module.exports = {"success":"ModalSuccess_success__331NO"};